import { sendClickHouseAnalytic } from '@shared/api/analytics/template'

// Уникальные события для страницы подборки
export const EGGSelectionItem = {
  // 1. Отобразился экран
  appear_screen_page: () =>
    sendClickHouseAnalytic({
      event_name: 'screen_appear',
    }),
}
